export enum KEYBOARD_KEYS {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  END = 'End',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  HOME = 'Home',
  TAB = 'Tab',
  SPACE = ' '
}

export const CHARCODES = {
  ENTER: 13
};

export const LIB_INPUTS_DEFAULT_IDS = {
  ACCOUNT_NUMBER: 'accountNumber',
  DOB: 'dateOfBirth',
  DISCONNECTION_DATE: 'dateOfDisconnection',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MOBILE: 'mobileNumber',
  PASSWORD: 'password',
  POSTCODE: 'postcode',
  VERIFICATION_CODE: 'verificationCode',
  SIM_NUMBER: 'simNumber',
  SIM_TYPE: 'simType'
} as const;

export const ARIA_CURRENT = 'page';
